import { useCallback, useState } from 'react'

export const useNotificationCenterToggle = (): [boolean, () => void] => {
    const [isOpened, setIsOpen] = useState(false)

    const toggle = useCallback(() => setIsOpen((prevState) => !prevState), [])

    return [isOpened, toggle]
}
